export default {
  'menu.adminTop': 'Administrator Home',
  'menu.adminTop.users': 'User Setting',
  'menu.adminTop.users.list': 'User List',
  'menu.adminTop.users.create': 'User Create',
  'menu.adminTop.users.edit': 'User Edit',
  'menu.adminTop.customers': 'Customer Management',
  'menu.adminTop.customers.list': 'Customer List',
  'menu.adminTop.customers.create': 'Customer Create',
  'menu.adminTop.customers.edit': 'Customer Edit',

  // Customer
  'menu.customerTop': 'Customer Home',

  'menu.customerTop.:schemaName.agencys': 'Agency Setting',
  'menu.customerTop.:schemaName.agencys.list': 'Agency List',
  'menu.customerTop.:schemaName.agencys.create': 'Agency Create',
  'menu.customerTop.:schemaName.agencys.edit': 'Agency Edit',
  
  'menu.customerTop.:schemaName.notices': 'Notice Setting',
  'menu.customerTop.:schemaName.notices.list': 'Notice List(Maximum of 5)',
  'menu.customerTop.:schemaName.notices.create': 'Notice Create',
  'menu.customerTop.:schemaName.notices.edit': 'Notice Edit',
  'menu.customerTop.:schemaName.route_groups': 'Route Group Setting',
  'menu.customerTop.:schemaName.route_groups.list': 'Route Group List',
  'menu.customerTop.:schemaName.route_groups.create': 'Route Group Create',
  'menu.customerTop.:schemaName.route_groups.edit': 'Route Group Edit',
  'menu.customerTop.:schemaName.stop_groups': 'Stop Group Setting',
  'menu.customerTop.:schemaName.stop_groups.list': 'Stop Group List',
  'menu.customerTop.:schemaName.stop_groups.create': 'Stop Group Create',
  'menu.customerTop.:schemaName.stop_groups.edit': 'Stop Group Edit',

  // --- 以下はテンプレ既存 ---
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.account.mypage': 'MyPage',
  'menu.account.setting': 'MySetting',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};